import React from "react";
import { Drawer, IconButton, Icons, Text } from "@pushpress/shared-components";
import ViewAvailability from "../ViewAvailability/ViewAvailability";
import styles from "./AvailabilityDrawer.module.scss";

type AvailabilityProps = {
  userUuid: string;
  visible: boolean;
  onClose: VoidFunction;
};

const AvailabilityDrawer = (props: AvailabilityProps) => {
  const { visible } = props;
  return (
    <Drawer
      visible={visible}
      anchor="right"
      width="400px"
      disableClickAway
      disableEscapeKeyDown
    >
      <AvailabilityDrawerContent {...props} />
    </Drawer>
  );
};

const AvailabilityDrawerContent = (props: AvailabilityProps) => {
  const { userUuid, onClose } = props;

  return (
    <div>
      <div className={styles.header}>
        <IconButton
          icon={Icons.X}
          onClick={onClose}
          className={styles.close}
          aria-label="Close"
        />
        <Text variant="heading-4" color="wolf-800">
          View Availability
        </Text>
      </div>
      <div className={styles.content}>
        <ViewAvailability userUuid={userUuid} />
      </div>
    </div>
  );
};

export default AvailabilityDrawer;
